import type { FC } from "react";
import React from "react";
import type { RouteComponentProps } from "react-router-dom";
import { Link } from "react-router-dom";
import { useRecoilValue } from "recoil";

import { BoardToggle } from "../../../layouts/components/board_toggle";
import { topicDataQuery } from "../../../state";
import { Title } from "../../basic/title/title";

type Props = {
    isAuthorized: boolean;
} & RouteComponentProps<{
    topicId: string;
}>;

const CourseTopicContainer: FC<any> = (props: Props) => {
    const topicId = parseInt(props.match.params.topicId, 10);
    const { content, data, sectionId, text } = useRecoilValue(topicDataQuery({ topicId }));

    if (!data) {
        return (
            <div className="course-topic">
                <Title backUrl="/education/" rightContent={<BoardToggle />} title="Тема не найдена" />
            </div>
        );
    }

    return (
        <div className="course-topic">
            <Title backUrl={`/section/${sectionId}/`} rightContent={<BoardToggle />} title={data.title} />
            <div dangerouslySetInnerHTML={{ __html: text || "" }} />
            <div className="course-topic__content">
                <div className="course-topic__content-container">
                    {content.map((v) => (
                        <p className="course-topic__content-title" key={`content_${v.id}`}>
                            <Link to={`/topic/${topicId}/content/${v.id}/`}>{v.title || <i>Контент № {v.id}</i>}</Link>
                        </p>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CourseTopicContainer;
